import { render, staticRenderFns } from "./invoiceAllocation.vue?vue&type=template&id=7fa896dc&scoped=true&"
import script from "./invoiceAllocation.vue?vue&type=script&lang=js&"
export * from "./invoiceAllocation.vue?vue&type=script&lang=js&"
import style0 from "./invoiceAllocation.vue?vue&type=style&index=0&id=7fa896dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa896dc",
  null
  
)

export default component.exports